import React from "react";
import { Card, Col, Container, Row } from "react-bootstrap";
import { NavLink } from "react-router-dom";
import TypeWriterEffect from "react-typewriter-effect";
import project1 from "../../../Images/project-1.PNG";
import project2 from "../../../Images/project-2.PNG";
import project3 from "../../../Images/project-3.PNG";

const Projects = () => {
  return (
    <div id="projects" className="py-4">
      <Container className="py-5">
        <h1 className="pb-5 ">
          <TypeWriterEffect
            textStyle={{
              textAlign: "center",
            }}
            startDelay={100}
            cursorColor="transparent"
            text="MY-PROJECTS"
            typeSpeed={100}
            // scrollArea={myAppRef}
          />
        </h1>
        <Row xs={1} md={2} lg={3} className="g-4 ">
          <Col className="position-relative project-info">
            <Card className="border-0 h-100 my-3">
              <Card.Img className="w-100" variant="top" src={project3} />
              <Card.Body className="project-overlay text-center">
                <h5 className="card-title">Camera-World</h5>
                <div className="">
                  <p className="card-text pt-3">
                    On this website you will find different types of cameras and
                    you can buy any camera of your choice with details
                    description.
                  </p>
                  <button className="common-btn m-2">
                    <a href="https://camera-world-fy.web.app/">Visit-Website</a>
                  </button>
                  <NavLink to="/projectDetails">
                    <button className="common-btn">Details</button>
                  </NavLink>
                </div>
              </Card.Body>
            </Card>
          </Col>
          <Col className="position-relative project-info">
            <Card className="border-0 h-100 my-3">
              <Card.Img className="w-100" variant="top" src={project1} />
              <Card.Body className="project-overlay text-center">
                <h5 className="card-title">Dentaverse</h5>
                <div className="">
                  <p className="card-text pt-3">
                    This is a dental service booking website where you can book
                    or cancel the dental service of your choice.
                  </p>

                  <button
                    style={{ color: "#04c2c9" }}
                    className="common-btn m-2"
                  >
                    <a href="https://dentaverse-73.web.app/">Visit-Website</a>
                  </button>
                  <NavLink to="/projectDetails">
                    <button className="common-btn">Details</button>
                  </NavLink>
                </div>
              </Card.Body>
            </Card>
          </Col>
          <Col className="position-relative project-info">
            <Card className="border-0 h-100 my-3">
              <Card.Img className="w-100" variant="top" src={project2} />
              <Card.Body className="project-overlay text-center">
                <h5 className="card-title">World-Tour</h5>
                <div className="">
                  <p className="card-text pt-3">
                    It is a tourism website where users can select and cancel
                    any tour package within their conveniently available
                    package.
                  </p>
                  <button className="common-btn m-2">
                    <a href="https://world-tour-fy.web.app/">Visit-Website</a>
                  </button>
                  <NavLink to="/projectDetails">
                    <button className="common-btn">Details</button>
                  </NavLink>
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Projects;
